import { Box, Container, Grid } from "@mui/material";
import SvgColor from '@src/components/svg-color';
import { AppWidgetSummary } from "@src/sections/@dashboard/app";
import palette from '@src/theme/palette';
import numeral from "numeral";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { usePurchasesService } from "./hooks";
import moment from "moment";
import { usePurchasesContext } from "./provider";

const Header = () => {
	const location = useLocation();
	const { state, handleClearFilters } = usePurchasesContext();
	const { totalPurchase } = usePurchasesService();

	const labelTotalPurchase = useMemo(() => {
		return `Total Purchases ${state.fromdate && state.todate ? 
			`(${moment(state.fromdate).format("DD MMM YYYY")} - ${moment(state.todate).format("DD MMM YYYY")})` 
			: `(${moment().format("MMMM")})`}`;

	},[state.fromdate, state.todate]);

	useEffect(() => {
		if(location.pathname){
			handleClearFilters();
		}
	},[location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

	const AppWidget2 = useMemo(() => {
		switch(location.pathname){
			case "/dashboard/purchase/points-purchases":
				return (
					<AppWidgetSummary
						disabled
						title={`Total Palms Points ${state.fromdate && state.todate ? 
							`(${moment(state.fromdate).format("DD MMM YYYY")} - ${moment(state.todate).format("DD MMM YYYY")})` 
							: `(${moment().format("MMMM")})`}`}
						value={numeral(totalPurchase?.totalAmount).format("0,000.00")}
						color={palette.orangeYellow.main}
						icon={<SvgColor src={`/assets/icons/ic_palm_tree.svg`} sx={{ width: 24, height: 24 }} />}
					/>
				)

			case "/dashboard/purchase/cash-purchases":
				return (
					<AppWidgetSummary
						disabled
						// title={"Total Amount of € (Month)"}
						title={`Total Amount of € ${state.fromdate && state.todate ? 
							`(${moment(state.fromdate).format("DD MMM YYYY")} - ${moment(state.todate).format("DD MMM YYYY")})` 
							: `(${moment().format("MMMM")})`}`}
						value={numeral(totalPurchase?.totalAmount).format("0,000.00")}
						color={palette.green.main}
						icon={"tabler:tax-euro"}
					/>
				)
			case "/dashboard/purchase/gold-purchases":
				return (
					<AppWidgetSummary
						disabled
						title={`Total Palms Gold Used for Purchases ${state.fromdate && state.todate ? 
							`(${moment(state.fromdate).format("DD MMM YYYY")} - ${moment(state.todate).format("DD MMM YYYY")})` 
							: `(${moment().format("MMMM")})`}`}
						value={numeral(totalPurchase?.totalAmount).format("0,000.00")}
						color={"#FFB800"}
						icon={(
							<Box
								sx={{
									width: 40,
									height: 40,
								}}
							>
								<img
									alt=""
									src={"/assets/icons/ic_palms_gold.svg"} />
							</Box>
						)}
					/>
				)
			default:
				return (
					<AppWidgetSummary
						disabled
						title={`Total Palms Points ${state.fromdate && state.todate ? 
							`(${moment(state.fromdate).format("DD MMM YYYY")} - ${moment(state.todate).format("DD MMM YYYY")})` 
							: `(${moment().format("MMMM")})`}`}
						value={numeral(totalPurchase?.totalAmount).format("0,000.00")}
						color={palette.orangeYellow.main}
						icon={<SvgColor src={`/assets/icons/ic_palm_tree.svg`} sx={{ width: 24, height: 24 }} />}
					/>
				)
		}
	},[location.pathname, totalPurchase?.totalAmount, state.fromdate, state.todate]);

	return (
		<Container>
			<Grid container 
				spacing={{
					xl: 3,
					lg: 3,
					md: 3,
					sm: 1.5,
					xs: 1.5
				}}>
				{location.pathname === "/dashboard/purchase/summary" ? null : <Grid item xs={12} sm={6} md={6} >
					<AppWidgetSummary
						disabled
						title={labelTotalPurchase}
						value={numeral(totalPurchase?.count).format("0,000.00")}
						color={"#16DBCC"}
						icon={<SvgColor src={`/assets/icons/ic_store.svg`} 
							sx={{ width: {
								xl: 24,
								lg: 24,
								md: 24,
								sm: 18,
								xs: 18
							}, height: {
								xl: 24,
								lg: 24,
								md: 24,
								sm: 18,
								xs: 18
							} }} />}
						/>
				</Grid>}
				<Grid item xs={12} sm={6} md={6} >
					{AppWidget2}
				</Grid>
			</Grid>
		</Container>
	)
}

export default Header